import { PublishTokenPayload, SeaartTokenPayload } from '../types'

/** JWT payload 字段基础类型，可通过泛型扩展具体业务字段 */
export interface JwtPayload {
  exp?: number
  iat?: number
  sub?: string
}

/**
 * 解析 JWT 中间段（payload），返回解码后的明文对象。
 * 不验证签名，仅做 Base64URL 解码 + JSON 反序列化。
 */
export function parseJwtPayload<T extends JwtPayload = JwtPayload>(token: string): T {
  const parts = token.split('.')
  if (parts.length !== 3) {
    throw new Error(`Invalid JWT format: expected 3 parts, got ${parts.length}`)
  }

  const base64 = parts[1]
    .replace(/-/g, '+')
    .replace(/_/g, '/')
    .padEnd(parts[1].length + ((4 - (parts[1].length % 4)) % 4), '=')

  let jsonStr: string
  try {
    const binaryStr = atob(base64)
    const bytes = Uint8Array.from(binaryStr, (c) => c.charCodeAt(0))
    jsonStr = new TextDecoder().decode(bytes)
  } catch {
    throw new Error('Failed to decode JWT payload: invalid Base64 encoding')
  }

  try {
    return JSON.parse(jsonStr) as T
  } catch {
    throw new Error('Failed to parse JWT payload: invalid JSON')
  }
}

/**
 * 解析 Seaart token 负载
 */
export function parseSeaartTokenPayload(token: string): SeaartTokenPayload['payload'] {
  try {
    return parseJwtPayload<SeaartTokenPayload>(token).payload
  } catch {
    return {
      identify_id: '',
      name: '',
      email: '',
    } as SeaartTokenPayload['payload']
  }
}

/**
 * 解析 PublishTokenPayload 负载
 */
export function parsePublishTokenPayload(token: string): PublishTokenPayload['payload'] {
  try {
    return parseJwtPayload<PublishTokenPayload>(token).payload
  } catch {
    return {
      union_id: '',
      open_id: '',
      name: '',
      avatar: '',
      identify_id: '',
    } as PublishTokenPayload['payload']
  }
}
